import moment from "moment";
import {
  GET_ADVERTISEMENT,
  SET_ORDER_BY,
  SET_PAGE,
  SET_SEARCH,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";

const initialAd = {
  advertisements: [],
  adCount: 0,
  page: 1,
  search: "",
  sortby: "",
  orderby: "desc",
};

function adReducers(state = initialAd, action) {
  switch (action.type) {
    case GET_ADVERTISEMENT:
      return {
        ...state,
        advertisements: action.payload.advertisement.map((ad) => {
          return {
            ...ad,

            updatedAtFormatted: moment(ad.createdAt).format("ll"),
          };
        }),

        adCount: action.payload.totalCount,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    default:
      return state;
  }
}

export default adReducers;
